import styled from 'styled-components';
import { breakpoints } from '../../constants/breakpoints';
import { PageContainer } from '../GenericComponents/PageContainer';

export const Container = styled(PageContainer)<{ isHpx: boolean }>`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 32px 0;
  box-sizing: border-box;
  margin: 0 auto;

  @media only screen and (max-width: ${breakpoints.smalldesktop}) {
    padding: 24px 24px;

    ${({ isHpx }) =>
      isHpx &&
      `
      display: flex;
      flex-direction: column;
  `}
  }

  @media screen and (min-width: ${breakpoints.wide}) {
    max-width: 64rem;
  }
`;

export const Title = styled.h4`
  font-weight: 500;

  @media only screen and (max-width: ${breakpoints.bigtablet}) {
    text-align: center;
  }
`;

export const SubTitle = styled.h2`
  @media only screen and (max-width: ${breakpoints.bigtablet}) {
    text-align: center;
  }
`;

export const SupportText = styled.div`
  flex-shrink: 2;
  padding: 1rem 0;
  margin-bottom: 1.5rem;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: ${breakpoints.bigtablet}) {
    flex-direction: column-reverse;

    > .slider-container {
      padding: 0 !important;
    }
  }
`;
